export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "please": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please input "])},
        "isRequiredField": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" is required."])}
      },
      "zh": {
        "please": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入"])},
        "isRequiredField": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["为必填字段"])}
      }
    }
  })
}
